import Totals from "../crew/Totals";
import BigNum from "../math/BigNum";
import BigNumSave from "./BigNumSave";
import ValuePerTurnSave from "./ValuePerTurnSave";

export default class TotalsSave {
    constructor() {        
    }

    /**
     * @param {Totals} totals
     * @returns {Object}
     */
    static generateSave(totals) {
        const saveState = {};

        saveState.ore = BigNumSave.save(totals.ore);
        saveState.gold = BigNumSave.save(totals.gold);
        saveState.ruby = BigNumSave.save(totals.ruby);
        saveState.prestige = BigNumSave.save(totals.prestige);
        saveState.prestigeSum = BigNumSave.save(totals.prestigePointsSum);
        saveState.unclaimed = BigNumSave.save(totals.unclaimedPrestige);

        saveState.prestigePerTurn = BigNumSave.save(totals.prestigePerTurn);
        saveState.goldPerTurn = BigNumSave.save(totals.goldPerTurn);
        saveState.orePerTurn = BigNumSave.save(totals.orePerTurn);
        saveState.rubyPerTurn = BigNumSave.save(totals.rubyPerTurn);

        saveState.offlinePrestige = BigNumSave.save(totals.offlinePrestige);
        saveState.offlineGold = BigNumSave.save(totals.offlineGold);
        saveState.offlineOre = BigNumSave.save(totals.offlineOre);
        saveState.offlineRuby = BigNumSave.save(totals.offlineRuby);

        saveState.offlineSeconds = totals.offlineSeconds;
        saveState.countedOfflineSeconds = totals.countedOfflineSeconds;

        saveState.prestigePerTurnCalc = ValuePerTurnSave.generateSave(totals.prestigeRatePerTurnCalculator);
        saveState.goldPerTurnCalc = ValuePerTurnSave.generateSave(totals.goldRatePerTurnCalculator);
        saveState.orePerTurnCalc = ValuePerTurnSave.generateSave(totals.oreRatePerTurnCalculator);
        saveState.rubyPerTurnCalc = ValuePerTurnSave.generateSave(totals.rubyRatePerTurnCalculator);

        return saveState;
    }

    /**
     * @param {Totals} totals
     * @param {Object} saveState 
     */
    static loadSave(totals, saveState) {
        if (!saveState) {
            return;
        }

        BigNumSave.load(saveState.ore, totals.ore);
        BigNumSave.load(saveState.gold, totals.gold);
        BigNumSave.load(saveState.ruby, totals.ruby);
        BigNumSave.load(saveState.prestige, totals.prestige);
        BigNumSave.load(saveState.prestigeSum, totals.prestigePointsSum);
        BigNumSave.load(saveState.unclaimed, totals.unclaimedPrestige);
        
        BigNumSave.load(saveState.prestigePerTurn, totals.prestigePerTurn);
        BigNumSave.load(saveState.goldPerTurn, totals.goldPerTurn);
        BigNumSave.load(saveState.orePerTurn, totals.orePerTurn);
        BigNumSave.load(saveState.rubyPerTurn, totals.rubyPerTurn);

        BigNumSave.load(saveState.offlinePrestige, totals.offlinePrestige);
        BigNumSave.load(saveState.offlineGold, totals.offlineGold);
        BigNumSave.load(saveState.offlineOre, totals.offlineOre);
        BigNumSave.load(saveState.offlineRuby, totals.offlineRuby);

        if (saveState.offlineSeconds) {
            totals.offlineSeconds = saveState.offlineSeconds;
        }
        if (saveState.countedOfflineSeconds) {
            totals.countedOfflineSeconds = saveState.countedOfflineSeconds;
        }

        ValuePerTurnSave.loadSave(totals.prestigeRatePerTurnCalculator, saveState.prestigePerTurnCalc);
        ValuePerTurnSave.loadSave(totals.goldRatePerTurnCalculator, saveState.goldPerTurnCalc);
        ValuePerTurnSave.loadSave(totals.oreRatePerTurnCalculator, saveState.orePerTurnCalc);
        ValuePerTurnSave.loadSave(totals.rubyRatePerTurnCalculator, saveState.rubyPerTurnCalc);


        // ***************** CHEATS TO GIVE ME ORE / POINTS

        // // DELETE THIS
        // const oreBonus = new BigNum(60000);
        // oreBonus.mulNumber(60000);
        // oreBonus.mulNumber(60000);
        // oreBonus.mulNumber(60000);
        // oreBonus.mulNumber(60000);
        // totals.incrementOre(oreBonus);

        // totals.incrementUnclaimedPrestige(new BigNum(30));
        /////totals.incrementPrestige(new BigNum(500));
        /////totals.prestige.add(new BigNum(5000));

       /////////totals.incrementGold(new BigNum(500000));

        //totals.prestige.add(new BigNum(20)); // ***************************
    }

}